import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { EstateFilters } from '../types';

export function useEstates(filters?: EstateFilters) {
  return useQuery({
    queryKey: ['estates', filters],
    queryFn: () => api.getEstates(filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useEstate(id: string) {
  return useQuery({
    queryKey: ['estate', id],
    queryFn: () => api.getEstate(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useFilterOptions() {
  return useQuery({
    queryKey: ['filterOptions'],
    queryFn: () => api.getFilterOptions(),
    staleTime: 1000 * 60 * 30, // 30 minutes - filter options rarely change
  });
}

